import { styled } from "../../../../../../styles";

export const TreatmentContainer = styled("div", {
  height: "100%",

  padding: "24px 18px 18px 48px",

  borderLeft: "1px solid $gray-30",

  "@media only screen and (max-width: 1250px)": {
    padding: "24px 2px 18px 10px",
  },

  variants: {
    isPinnedGraph: {
      true: {
        maxWidth: "531px",
      },
    },
  },
});

export const DataContainer = styled("div", {
  width: "370px",
  height: "100%",

  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "10px",

  fontFamily: "$openSans",
  color: "$gray-90",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: 0,

  marginRight: 14,
});

export const Row = styled("div", {
  width: "100%",

  display: "flex",
  flexDirection: "row",
});

export const Name = styled("p", {
  width: "200px",
});
